module.exports = __webpack_public_path__ + "img/prestaz_invoiceweb.5082272c.png";